export default "__VITE_ASSET__CIVe7ows__"